<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title><strong>{{ data.esNuevo ? 'Crear' : data.esEliminar ? 'Eliminar': data.esVista
? 'Ver' : 'Modificar' }} </strong></h2>

@if (!data.esVista) {
  <mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <form [formGroup]="form">
      @if (data.esEliminar) {
        ¿Esta seguro que desea eliminar el registro <b>{{data.descripcion}}</b>?
      } @else {
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Descripción</mat-label>
          <input cdkFocusInitial matInput type="text" maxlength="100" style="text-transform: uppercase"
            formControlName="Descripcion" />
            @if (f.Descripcion.errors?.required) {
              <mat-error
                >Este campo es <strong>requerido</strong>.</mat-error
                >
            }
            @if (f.Descripcion.errors?.maxlength) {
              <mat-error
                >Superó el largo máximo.</mat-error
                >
              }
            </mat-form-field>
            @if (!data.esEliminar) {
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Observaciones</mat-label>
                <textarea matInput #message name="Observaciones" formControlName="Observaciones"
                ></textarea>
                <mat-hint align="start">Amplie información</mat-hint>
                <mat-hint align="end">{{ message.value.length }} / 200</mat-hint>
                @if (form.controls['Observaciones'].hasError('maxlength')) {
                  <mat-error>Supero el largo maximo.</mat-error>
                }
              </mat-form-field>
            } @else {
              <ng-template [ngTemplateOutlet]="elseTemplate"></ng-template>
            }
          }
        </form>
      </mat-dialog-content>
    }

    @if (data.esVista) {
      <mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
        @if (data) {
          <div>
            <div class="property-row">
              <span class="property-name">Descripción:</span>
              <span class="property-value"> {{ data.item?.descripcion}}</span>
            </div>
            <div class="property-row">
              <span class="property-name">Observaciones:</span>
              <span class="property-value"> {{ data.item?.observaciones }}</span>
            </div>
          </div>
        }
      </mat-dialog-content>
    }


    <mat-dialog-actions align="end">
      <app-button-cancel-dialog></app-button-cancel-dialog>
      <app-button-add  [disabled]="!form.valid" (addClicked)="agregar()"></app-button-add>

      @if (data.esEditar) {
        <app-button-save [disabled]="!form.valid" [isDialogClose]="true" (saveClicked)="modificar()"
        (cancelClicked)="cancelar()"></app-button-save>
      }

      @if (data.esEliminar) {
        <app-button-delete-and-cancel (deleteClicked)="eliminar()" (cancelClicked)="cancelar()"
        [isDialogClose]="true"></app-button-delete-and-cancel>
      }


      @if (data.esVista) {
        <app-button-close></app-button-close>
      }
    </mat-dialog-actions>
